import Konva from "konva";
import store from "@/store/store";

export class DMCObject {
  constructor(name, konvaObject) {
    if (name == undefined || konvaObject == undefined) {
      this.name = null;
      this.konvaObject = null;
      return;
    }
    this.name = name;

    this.konvaObject = konvaObject;
    this.konvaObjectOption = konvaObject.attrs;
    this.renderObject = null;

    this.animMvt = null;
    this.animEasing = null;
    this.animSpeed = null;
    this.animValue = null;
    this.animDelay = null;
    this.animObj = null;

    this.animOutMvt = null;
    this.animOutEasing = null;
    this.animOutSpeed = null;
    this.animOutValue = null;
    this.animOutDelay = null;
    this.animOutObj = null;

    this.stageSize = {
      width: store.state.project.properties.width,
      height: store.state.project.properties.height,
    };
  }

  // Méthode pour sauvegarder l'animation
  saveAnimation() {
    let anim = {
      animMvt: this.animMvt,
      animEasing: this.animEasing,
      animSpeed: this.animSpeed,
      animValue: this.animValue,
      animDelay: this.animDelay,

      animOutMvt: this.animOutMvt,
      animOutEasing: this.animOutEasing,
      animOutSpeed: this.animOutSpeed,
      animOutValue: this.animOutValue,
      animOutDelay: this.animOutDelay,
    };

    return anim;
  }

  // Méthode pour charger l'animation
  loadAnimation(animationData, stageSize = null) {
    this.animMvt = animationData.animMvt;
    this.animEasing = animationData.animEasing;
    this.animSpeed = animationData.animSpeed;
    this.animValue = animationData.animValue;
    this.animDelay = animationData.animDelay;

    this.animOutMvt = animationData.animOutMvt;
    this.animOutEasing = animationData.animOutEasing;
    this.animOutSpeed = animationData.animOutSpeed;
    this.animOutValue = animationData.animOutValue;
    this.animOutDelay = animationData.animOutDelay;

    this.stageSize =
      stageSize != null
        ? stageSize
        : {
            width: store.state.project.properties.width,
            height: store.state.project.properties.height,
          };
  }

  // Méthode pour copier les options
  copyOption(DMCObject, controllerProject) {
    let newOption = {};
    newOption.x = DMCObject.konvaObjectOption.x;
    newOption.y = DMCObject.konvaObjectOption.y;
    newOption.width = DMCObject.konvaObjectOption.width;
    newOption.height = DMCObject.konvaObjectOption.height;
    newOption.scaleX = DMCObject.konvaObjectOption.scaleX;
    newOption.scaleY = DMCObject.konvaObjectOption.scaleY;
    newOption.rotation = DMCObject.konvaObjectOption.rotation;
    newOption.name = DMCObject.konvaObjectOption.name;
    newOption.id = DMCObject.konvaObjectOption.id;
    newOption.fill = DMCObject.konvaObjectOption.fill;
    newOption.movable = DMCObject.konvaObjectOption.movable;
    newOption.editable = DMCObject.konvaObjectOption.editable;
    newOption.draggable = true;

    newOption.dragBoundFunc = function (pos) {
      if (!controllerProject.canObjectMove) {
        return {
          x: this.absolutePosition().x,
          y: this.absolutePosition().y,
        };
      } else {
        return {
          x: pos.x,
          y: pos.y,
        };
      }
    };
    return newOption;
  }

  // Méthode pour supprimer l'objet
  delete() {
    return;
  }

  // Méthode appelée lors de la désélection de l'objet
  deselect() {
    return;
  }

  // Méthode pour obtenir le type de l'objet
  getType() {
    return "DMCObject";
  }

  // Méthode pour charger un objet à partir d'un fichier de sauvegarde
  load(controllerProject, DMCObject, incorporate = true) {
    this.name = DMCObject.name;
    DMCObject.konvaObjectOption = this.copyOption(DMCObject, controllerProject);
    this.konvaObject = this.createNewObject(DMCObject);
    this.konvaObjectOption = this.konvaObject.attrs;
    this.initialOptions = JSON.parse(JSON.stringify(this.konvaObject.attrs));

    if (incorporate) {
      controllerProject.addElementToCurrentLayer(this.konvaObject);
    }

    this.loadEnd(DMCObject);
    return this;
  }

  // Méthode appelée à la fin du chargement de l'objet
  loadEnd(obj) {
    return obj;
  }

  // Méthode pour obtenir les options correspondant à cet objet
  options() {
    return ["Rect"];
  }

  // Méthode pour rendre un aperçu de l'objet
  // eslint-disable-next-line no-unused-vars
  renderPreview(layer = null) {
    this.renderObject = this.konvaObject.clone();
    this.renderObject.attrs.draggable = false;
    this.renderObject.isClone = true;
    this.renderObject.attrs.dragBoundFunc = function () {
      return {
        x: this.absolutePosition().x,
        y: this.absolutePosition().y,
      };
    };

    layer.add(this.renderObject);
    this.createAnimation(this.renderObject);
    //this.createAnimationOut(this.renderObject);

    return {
      object: this.renderObject,
      zIndex: this.konvaObject.zIndex(),
    };
  }

  deepCopySafe(value, seen = new WeakMap()) {
    if (value === null || value === undefined) return value;
    if (typeof value === "function") return value;
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return value;

    if (typeof value === "object") {
      if (seen.has(value)) return seen.get(value);
      if (value.constructor && value.constructor.name.startsWith("Konva")) return value;
      if (this.isDOMOrSpecial(value)) return value;

      const copy = Array.isArray(value) ? [] : {};
      seen.set(value, copy);
      for (const k in value) {
        copy[k] = this.deepCopySafe(value[k], seen);
      }
      return copy;
    }

    return value;
  }

  isDOMOrSpecial(obj) {
    if (obj === null || obj === undefined) return false;
    return obj instanceof Event || obj instanceof Node || (obj.constructor && obj.constructor.name === "CSSStyleSheet");
  }

  clone(controllerProject, incorporate = true) {
    const type = this.getType();
    const newId = this.makeName(controllerProject, type);
    const clonedKonva = this.konvaObject.clone({
      x: this.konvaObject.x() + 20,
      y: this.konvaObject.y() + 20,
      id: newId,
    });

    const ObjectClass = this.constructor;
    const clonedDMC = new ObjectClass(newId, clonedKonva);
    clonedDMC.loadAnimation(this.saveAnimation(), this.stageSize);
    clonedDMC.initialOptions = JSON.parse(JSON.stringify(clonedKonva.attrs));

    Object.keys(this).forEach((key) => {
      if (
        ![
          "konvaObject",
          "konvaObjectOption",
          "initialOptions",
          "currentOptions",
          "group",
          "renderObject",
          "name",
        ].includes(key)
      ) {
        const value = this[key];
        if (typeof value !== "function" && !this.isDOMOrSpecial(value)) {
          clonedDMC[key] = this.deepCopySafe(value);
        }
      }
    });

    if (incorporate) {
      controllerProject.addElementToCurrentLayer(clonedKonva);

      controllerProject.elements[newId] = clonedDMC;
    }

    return newId;
  }

  makeName(controllerProject, elementName) {
    let extra = "";
    switch (elementName) {
      case "Weather":
        extra = " : " + controllerProject.currentElement.dataWeather.city;
        break;
      case "Web":
        extra = " : " + controllerProject.currentElement.source;
        break;

      default:
        break;
    }
    const keyElement = elementName + " " + controllerProject.elementsNumber++ + extra;
    return keyElement;
  }

  // Méthode pour sauvegarder l'objet
  save() {
    return null;
  }

  // Méthode pour sélectionner l'objet
  select() {
    return;
  }

  // Méthode pour démarrer l'aperçu de l'objet
  startPreview() {
    if (!this.animObj) this.createAnimation();
    if (this.animObj != null) {
      let delay = parseInt(this.animDelay) * 1000;
      setTimeout(() => {
        this.animObj.play();
      }, delay);
    }
  }
  // Méthode pour démarrer l'aperçu de l'objet
  startPreviewOut() {
    //if(!this.animOutObj) {
    this.createAnimationOut(this.renderObject);
    //}
    if (this.animOutObj) {
      let delay = parseInt(this.animOutDelay) * 1000;
      setTimeout(() => {
        this.animOutObj.play();
      }, delay);
    }
  }

  // Méthode pour arrêter l'aperçu de l'objet
  stopPreview() {
    return;
  }

  // Méthode pour créer une animation
  // Quand un kObj est passé en paramètre : c'est le clone pour la preview
  createAnimation(kObj = null) {
    kObj = kObj == null ? this.konvaObject : kObj;

    //animation d'entree
    if (this.animMvt != null && this.animEasing != null && this.animSpeed != null) {
      switch (this.animMvt) {
        case "move":
          if (this.animValue != null) {
            this.translateAnimation(kObj);
          }
          break;
        case "opacity":
          this.opacityAnimation(kObj);
          break;
        case "scale":
          this.scaleAnimation(kObj);
          break;
        default:
          console.warn("animation mvt unknown");
          break;
      }
    }
  }

  createAnimationOut(kObj = null) {
    kObj = kObj == null ? this.konvaObject : kObj;
    //animation de sortie
    if (this.animOutMvt != null && this.animOutEasing != null && this.animOutSpeed != null) {
      switch (this.animOutMvt) {
        case "move":
          if (this.animOutValue != null) {
            this.translateAnimationOut(kObj);
          }
          break;
        case "opacity":
          this.opacityAnimationOut(kObj);
          break;
        case "scale":
          this.scaleAnimationOut(kObj);
          break;
        default:
          console.warn("animation mvt unknown");
          break;
      }
    }
  }

  // Méthode pour l'animation d'opacité
  opacityAnimation(kObj) {
    kObj.setAttr("opacity", 0);

    this.animObj = new Konva.Tween({
      node: kObj,
      duration: parseFloat(this.animSpeed),
      easing: this.getEasing(),
      opacity: 1,
    });
  }
  // Méthode pour l'animation d'opacité (sortie)
  opacityAnimationOut(kObj) {
    this.animOutObj = new Konva.Tween({
      node: kObj,
      duration: parseFloat(this.animOutSpeed),
      easing: this.getEasing("OUT"),
      opacity: 0,
    });
  }

  // Méthode pour l'animation de mise à l'échelle
  scaleAnimation(kObj) {
    const origX = kObj.attrs.x;
    const origY = kObj.attrs.y;
    const origScaleX = kObj.attrs.scaleX;
    const origScaleY = kObj.attrs.scaleY;

    kObj.setAttr("x", origX + (kObj.attrs.width * origScaleX) / 2);
    kObj.setAttr("y", origY + (kObj.attrs.height * origScaleY) / 2);
    kObj.setAttr("scaleX", 0);
    kObj.setAttr("scaleY", 0);

    this.animObj = new Konva.Tween({
      node: kObj,
      duration: parseFloat(this.animSpeed),
      easing: this.getEasing(),
      scaleX: origScaleX,
      scaleY: origScaleY,
      x: origX,
      y: origY,
    });
  }

  scaleAnimationOut(kObj) {
    const origScaleX = kObj.attrs.scaleX;
    const origScaleY = kObj.attrs.scaleY;
    const origX = kObj.attrs.x + (kObj.attrs.width * origScaleX) / 2;
    const origY = kObj.attrs.y + (kObj.attrs.height * origScaleY) / 2;

    this.animOutObj = new Konva.Tween({
      node: kObj,
      duration: parseFloat(this.animOutSpeed),
      easing: this.getEasing("OUT"),
      scaleX: 0,
      scaleY: 0,
      x: origX,
      y: origY,
    });
  }

  // Méthode pour l'animation de translation
  translateAnimation(kObj) {
    const origX = kObj.attrs.x;
    const origY = kObj.attrs.y;
    const width = kObj.attrs.width * kObj.attrs.scaleX;
    const height = kObj.attrs.height * kObj.attrs.scaleY;

    let stageWidth = store.state.project.properties.width;
    let stageHeight = store.state.project.properties.height;

    const limitNX = width * -1;
    const limitPX = stageWidth;
    const limitNY = height * -1;
    const limitPY = stageHeight;

    switch (this.animValue) {
      case "left":
        kObj.setAttr("x", limitNX);
        break;
      case "right":
        kObj.setAttr("x", limitPX);
        break;
      case "top":
        kObj.setAttr("y", limitNY);
        break;
      case "bottom":
        kObj.setAttr("y", limitPY);
        break;
    }

    this.animObj = new Konva.Tween({
      node: kObj,
      duration: parseFloat(this.animSpeed),
      easing: this.getEasing(),
      x: origX,
      y: origY,
    });
  }

  translateAnimationOut(kObj) {
    const origX = kObj.attrs.x;
    const origY = kObj.attrs.y;
    const width = kObj.attrs.width * kObj.attrs.scaleX;
    const height = kObj.attrs.height * kObj.attrs.scaleY;

    let stageWidth = store.state.project.properties.width;
    let stageHeight = store.state.project.properties.height;

    const limitNX = width * -1;
    const limitPX = stageWidth;
    const limitNY = height * -1;
    const limitPY = stageHeight;

    let targetX = origX;
    let targetY = origY;
    switch (this.animOutValue) {
      case "left":
        targetX = limitNX;
        break;
      case "right":
        targetX = limitPX;
        break;
      case "top":
        targetY = limitNY;
        break;
      case "bottom":
        targetY = limitPY;
        break;
    }

    this.animOutObj = new Konva.Tween({
      node: kObj,
      duration: parseFloat(this.animOutSpeed),
      easing: this.getEasing("OUT"),
      x: targetX,
      y: targetY,
    });
  }

  // Setters
  setAnimMvt(val, role) {
    if (role == "IN") this.animMvt = val;
    else if (role == "OUT") this.animOutMvt = val;
  }

  setAnimValue(val, role) {
    if (role == "IN") this.animValue = val;
    else if (role == "OUT") this.animOutValue = val;
  }

  setAnimEasing(val, role) {
    if (role == "IN") this.animEasing = val;
    else if (role == "OUT") this.animOutEasing = val;
  }

  setAnimSpeed(val, role) {
    if (role == "IN") this.animSpeed = val;
    else if (role == "OUT") this.animOutSpeed = val;
  }

  setAnimDelay(val, role) {
    if (role == "IN") this.animDelay = val;
    else if (role == "OUT") this.animOutDelay = val;
  }

  setAlign(val) {
    return val;
  }

  setColor(val) {
    return val;
  }

  setFont(val) {
    return val;
  }

  setSize(val) {
    return val;
  }

  setSpeed(val) {
    return val;
  }

  // Getters
  getEasing(role) {
    let easing = Konva.Easings.Linear;

    let anim = role == "OUT" ? this.animOutEasing : this.animEasing;
    switch (anim) {
      case "easeIn":
        easing = Konva.Easings.EaseIn;
        break;
      case "easeOut":
        easing = Konva.Easings.EaseOut;
        break;
      case "easeInOut":
        easing = Konva.Easings.EaseInOut;
        break;
      case "elasticEaseIn":
        easing = Konva.Easings.ElasticEaseIn;
        break;
      case "elasticEaseOut":
        easing = Konva.Easings.ElasticEaseOut;
        break;
      case "elasticEaseInOut":
        easing = Konva.Easings.ElasticEaseInOut;
        break;
      case "bounceEaseIn":
        easing = Konva.Easings.BounceEaseIn;
        break;
      case "bounceEaseOut":
        easing = Konva.Easings.BounceEaseOut;
        break;
      case "bounceEaseInOut":
        easing = Konva.Easings.BounceEaseInOut;
        break;
      default:
        break;
    }

    return easing;
  }

  reset() {
    if (this.initialOptions == null) return;
    //replace l'élément à sa position initiale (enregistré au moment du load)
    this.konvaObject.setAttr("x", this.initialOptions.x);
    this.konvaObject.setAttr("y", this.initialOptions.y);
    this.konvaObject.setAttr("scaleX", this.initialOptions.scaleX);
    this.konvaObject.setAttr("scaleY", this.initialOptions.scaleY);
    this.konvaObject.setAttr("opacity", 1);
  }
}
